import React, { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { request } from 'graphql-request';
import { Box } from '@mui/material';
import useSWR from 'swr';

import { BoxFlex, Typography, TextField, Icon, Dropdown } from '@tucar/pit-stop';
import GET_FAQ from '../../../graphql/querys/faq';
import LoadingProgress from '../../../components/ui/LoadingProgress';
import TopNav2 from '../../../components/ui/TopNav/newTopNav';
import { azulTucar } from '../../../themes/variants/TucarColors';
import AccordeonFAQ from './accordeonFaq';

const fetcher = (query) => request(process.env.API_FAQ, query);

const FAQScreen = () => {
  const [handlePageChange] = useOutletContext();
  const { data, loading } = useSWR(GET_FAQ.query, fetcher);
  const [questionList, setQuestionList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTheme, setSearchTheme] = useState({ name: 'Todos los temas', value: '' });

  useEffect(() => {
    handlePageChange(null, true);
  }, []);

  useEffect(() => {
    if (data && data.preguntasFrecuente) {
      const listIds = data.preguntasFrecuente;
      const removeKeys = ['subtitle', 'id', 'title', 'title2'];
      const filteredList = listIds.map((item) => {
        const newItem = { ...item };
        removeKeys.forEach((key) => {
          delete newItem[key];
        });
        return newItem;
      })[0];

      const ListQuestions = Object.keys(filteredList)
        .map((key) => {
          const NewList = [];
          filteredList[key].forEach((item) => {
            const newItem = { ...item, section: key };
            NewList.push(newItem);
          });
          return NewList;
        })
        .reduce((acc, curr) => acc.concat(curr), []);

      setQuestionList(ListQuestions);
    }
  }, [data]);

  const filteredQuestions = questionList.filter((item) => {
    const termFiltered = item.title.toLowerCase().includes(searchTerm.toLowerCase());
    if (searchTheme.value === '') {
      return termFiltered;
    }
    const themeFiltered = item.section.toLowerCase().includes(searchTheme.value.toLowerCase());
    return themeFiltered && termFiltered;
  });

  if (!data || loading) {
    return (
      <Box sx={{ heigth: '100%' }}>
        <LoadingProgress allScreen />
      </Box>
    );
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <TopNav2 title="Preguntas Frecuentes" />

      <BoxFlex flexDirection="column" style={{ padding: '0px 30px' }}>
        <Typography
          color={azulTucar}
          style={{
            fontSize: '18px',
            fontWeight: 500,
          }}
        >
          Estamos aquí para ayudarte
        </Typography>
        <Typography
          color="#5B5D71"
          style={{
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: 1.14,
            marginTop: '14px',
          }}
        >
          Accede a nuestras preguntas frecuentes en la aplicación para respuestas rápidas. Si no
          encuentras lo que buscas, inicia un chat con nuestros ejecutivos para asistencia
          personalizada.
        </Typography>

        <Typography
          color={azulTucar}
          style={{
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: 1.2,
            marginTop: '43px',
            marginBottom: '30px',
          }}
        >
          Preguntas frecuentes
        </Typography>

        <TextField
          label=""
          variant="outlined"
          onlyLabel
          fullWidth
          endAdornment={<Icon name="searchOutlined" color={azulTucar} />}
          value={searchTerm}
          onChange={(value) => {
            setSearchTerm(value);
          }}
          style={{ marginBottom: '20px' }}
        />

        <Dropdown
          fullWidth
          label="Temas"
          placeholder="Seleccionar"
          value={searchTheme}
          options={[
            { name: 'Todos los temas', value: '' },
            { name: 'Detalles de usabilidad', value: 'detallesDetail' },
            { name: 'Dudas generales del servicio', value: 'dudasDetail' },
            { name: 'Pagos', value: 'pagosDetail' },
            { name: 'Conductores', value: 'preguntasDetail' },
            { name: 'Seguros y asistencia en ruta', value: 'segurosDetail' },
          ]}
          onChange={(value) => setSearchTheme(value)}
          getOptionLabel={(option) => option.name}
        />
      </BoxFlex>
      <Box style={{ paddingBottom: '20px', paddingTop: '50px' }}>
        {filteredQuestions.map((item) => (
          <AccordeonFAQ key={item.id} data={item} />
        ))}
      </Box>
    </Box>
  );
};

export default FAQScreen;
